// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3YZhQ","notes":"Notes_notes__2Dp_0","note":"Notes_note__Woi9c","markdown":"Notes_markdown__3LMnJ"};